// src/components/casino/GameCard.jsx
import React, { useState } from 'react';

const GameCard = ({ game, onPlay, isAuthenticated }) => {
  const [imageError, setImageError] = useState(false);

  // Get provider logo or fallback icon
  const getProviderIcon = (provider) => {
    const icons = {
      'pragmatic': '🎰',
      'novomatic': '🎰',
      'microgaming': '🎰',
      'netent': '🎰',
      'play_n_go': '🎰',
      'evolution': '🎲',
      'egt': '🎰',
      'amatic': '🎰',
      'aristocrat': '🎰',
      'quickspin': '🎰',
      'habanero': '🎰',
      'pgsoft': '🎰',
      '3oaks': '🎰',
      'playson': '🎰',
      'booming': '🎰',
      'hacksaw': '🎰',
      'rubyplay': '🎰',
      'spribe': '✈️',
      'yggdrasil': '🌳',
      'igrosoft': '🎰',
      'igt': '🎰',
      'wazdan': '🎰',
      'apollo': '🎰',
      'royal': '👑'
    };
    return icons[provider] || '🎮';
  };

  // Truncate long names
  const truncateName = (name, maxLength = 20) => {
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength) + '...';
  };

  const imageUrl = game.img || game.image || `https://rocketapi.online/cdn/slgames/${game.id}.jpg`;

  return (
    <div className="bg-gray-900 rounded-xl overflow-hidden hover:transform hover:scale-[1.02] transition-all duration-300 border border-gray-800 h-full flex flex-col">
      {/* Game Image */}
      <div className="relative h-40 bg-gradient-to-br from-purple-900/30 to-blue-900/30 cursor-pointer overflow-hidden flex-shrink-0">
        {!imageError ? (
          <img
            src={imageUrl}
            alt={game.name}
            className="w-full h-full object-cover"
            onError={() => setImageError(true)}
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <div className="text-5xl">{getProviderIcon(game.provider)}</div>
          </div>
        )}
        
        {/* Badges */}
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {game.demo === '1' && (
            <span className="bg-green-600 text-white px-2 py-0.5 rounded-full text-[10px] font-semibold">
              DEMO
            </span>
          )}
          {game.is_new && (
            <span className="bg-blue-600 text-white px-2 py-0.5 rounded-full text-[10px] font-semibold animate-pulse">
              NEW
            </span>
          )}
        </div>
        
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-black/60 opacity-0 hover:opacity-100 transition-opacity flex items-center justify-center">
          <button 
            onClick={() => onPlay(game)}
            className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white px-4 py-2 rounded-lg font-semibold transform hover:scale-105 transition-all text-sm"
          >
            {isAuthenticated ? '▶ Play' : '🔒 Login'}
          </button>
        </div>
      </div>
      
      {/* Game Info - Flex column with proper spacing */}
      <div className="p-3 flex flex-col flex-1">
        <div className="flex-1">
          <h3 className="text-sm font-bold text-white truncate" title={game.name}>
            {truncateName(game.name, 22)}
          </h3>
          <p className="text-xs text-gray-400 truncate" title={game.provider}>
            {game.provider}
          </p>
        </div>
        
        {/* Provider Tag */}
        <div className="mt-2 pt-2 border-t border-gray-800 flex items-center justify-between">
          <span className="text-[10px] text-gray-500 truncate max-w-[70%]" title={game.provider}>
            {game.provider}
          </span>
          <span className="text-[10px] text-gray-500">
            {game.type || 'slots'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default GameCard;